import { COMMENT_TYPE } from '../global/constants';
import { createNewComment, updateTaskDetails } from '../services/taskServices';
import { trackAnalyticActivity } from '../services/analyticsService';
import { TASK_ANALYTICS } from '../global/analyticsConstants';
import { StatusListInterface } from '../interfaces/ProjectInterface';
import { Dispatch } from 'react';
import { AnyAction } from 'redux';
import { TaskModel } from '../mobx/models/task';
import { getRawComment } from '../helpers/common';
import { nanoid } from 'nanoid';
import { rootStore } from '../mobx/rootStore';

export const checkSubtaskStatus = (task: TaskModel) => {
  let allSubTasksStatus = true;
  if (task?.subTasks && task?.subTasks?.length > 0) {
    for (const subTask of task.subTasks) {
      if (subTask?.status === false) {
        allSubTasksStatus = false;
        break;
      }
    }
  }
  return allSubTasksStatus;
};

export const dispatchTaskUpdates = async (item: TaskModel, value: boolean, dispatch: Dispatch<AnyAction>) => {
  const currentUser = rootStore.currentUser;
  if (!currentUser) return;
  const payloadTask = { status: value, projectId: item?.projectId };
  const newComment = {
    id: nanoid(),
    type: COMMENT_TYPE.STATUS_CHANGE,
    status: value
  };
  const updatedComment = getRawComment(newComment, currentUser);
  item.upsertComment(updatedComment);
  await dispatch(updateTaskDetails(item?.id, payloadTask));
  await dispatch(
    createNewComment(item?.id, {
      Type: COMMENT_TYPE.STATUS_CHANGE,
      Status: value
    })
  );
  if (item?.subTasks && item?.subTasks?.length > 0 && value) {
    const updatePromises = item.subTasks.map((subTask) => {
      return dispatch(updateTaskDetails(subTask.id, payloadTask));
    });
    const updateSubTaskComments = item.subTasks.map((subTask) => {
      return dispatch(
        createNewComment(subTask.id, {
          Type: COMMENT_TYPE.STATUS_CHANGE,
          Status: true
        })
      );
    });
    await Promise.all(updatePromises);
    await Promise.all(updateSubTaskComments);
  }

  if (true) {
    if (value) trackAnalyticActivity(TASK_ANALYTICS.MARKED_DONE);
    else {
      trackAnalyticActivity(TASK_ANALYTICS.REOPENED);
    }
  }
};

export const onUpdateStatus = async (
  task: TaskModel,
  status: StatusListInterface,
  previousStatus: StatusListInterface,
  isSubTaskUpdate: boolean,
  dispatch: Dispatch<AnyAction>
) => {
  // Return if status is not changed
  if (status?.['_id'] === previousStatus?.['_id']) {
    return;
  }
  //find subtasks that need to be updated
  const subTasksToUpdate =
    isSubTaskUpdate && task?.subTasks?.length
      ? task.subTasks.filter((subTask) => subTask?.statusDetails?.['_id'] !== status?.['_id'])
      : [];

  task.setStatus(status['_id'], isSubTaskUpdate);
  const currentUser = rootStore.currentUser;
  if (!currentUser) return;
  const payloadTask = { statusId: status['_id'], projectId: task?.projectId };

  if (isSubTaskUpdate && subTasksToUpdate.length > 0) {
    const updatePromises = subTasksToUpdate.map((subTask) => {
      return dispatch(updateTaskDetails(subTask.id, payloadTask));
    });
    const updateSubTaskComments = subTasksToUpdate.map((subTask) => {
      return dispatch(
        createNewComment(subTask.id, {
          Type: COMMENT_TYPE.STATUS_ID_CHANGE,
          Group: status?.Name,
          Priority: status?.Type
        })
      );
    });
    await Promise.all(updatePromises);
    await Promise.all(updateSubTaskComments);
  }

  const newComment = {
    id: nanoid(),
    type: COMMENT_TYPE.STATUS_ID_CHANGE,
    group: status?.Name,
    previousGroup: previousStatus?.Name,
    priority: status?.Type
  };
  const updatedComment = getRawComment(newComment, currentUser);
  task.upsertComment(updatedComment);
  await dispatch(updateTaskDetails(task?.id, payloadTask));
  await dispatch(
    createNewComment(task?.id, {
      Type: COMMENT_TYPE.STATUS_ID_CHANGE,
      Group: status?.Name,
      PreviousGroup: previousStatus?.Name,
      Priority: status?.Type
    })
  );
  trackAnalyticActivity(TASK_ANALYTICS.STATUS_CHANGED);
};
